import { Breadcrumb as AntdBreadcrumb, theme } from 'antd';
import { FC, memo, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useAppBreadcrumb } from '@/common/hooks';

import './AppBreadcrumb.scss';


export const AppBreadcrumb: FC = memo(() => {
  const location = useLocation();
  const { breadcrumb: appBreadcrumb, routesToDisable } = useAppBreadcrumb();
  const { colorBorderSecondary, yellow1 } = theme.useToken().token;

  const breadcrumbItems = useMemo(
    () =>
      appBreadcrumb.map((bc) => {
        const condition = bc.key === location.pathname || routesToDisable.has(bc.key);

        return {
          title: condition ? bc.breadcrumb : <Link data-hui="sdsd" to={ bc.key }>{ bc.breadcrumb }</Link>
        };
      }),
    [location.pathname, appBreadcrumb]
  );

  return <>
    {
      location.pathname !== '/' &&
      <AntdBreadcrumb
        className="common-layout__breadcrumb"
        items={ breadcrumbItems }
        style={{ border: `1px solid ${ colorBorderSecondary }`, backgroundColor: yellow1 }}
      />
    }
  </>;
});
